import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9cdd50a6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "sc-sender"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-column-notcentered"
}, [/*#__PURE__*/_createElementVNode("span", null, "Ваши данные"), /*#__PURE__*/_createElementVNode("span", {
  class: "sub-label"
}, "Пожалуйста, введите Ваше имя и фамилию.")], -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-column-notcentered"
}, [/*#__PURE__*/_createElementVNode("span", null, "Номер телефона"), /*#__PURE__*/_createElementVNode("span", {
  class: "sub-label"
}, "Введите Ваш номер телефона для обратной связи.")], -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-column-notcentered"
}, [/*#__PURE__*/_createElementVNode("span", null, "Для одной аптеки?"), /*#__PURE__*/_createElementVNode("span", {
  class: "sub-label"
}, "Укажите, Ваше предложение для определенной аптеки?")], -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-column-notcentered"
}, [/*#__PURE__*/_createElementVNode("span", null, "Выберите аптеку"), /*#__PURE__*/_createElementVNode("span", {
  class: "sub-label"
}, "Укажите нужную аптеку по её адресу.")], -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-column-notcentered"
}, [/*#__PURE__*/_createElementVNode("span", null, "Тип сотрудничества"), /*#__PURE__*/_createElementVNode("span", {
  class: "sub-label"
}, "Укажите, что Вы хотите предложить?")], -1));
const _hoisted_7 = {
  class: "flex-column-notcentered"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Заголовок предложения", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sub-label"
}, "Заголовок/тема Вашего предложения.", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Заголовок жалобы", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sub-label"
}, "Заголовок/тип/тема жалобы.", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Заголовок сотрудничества", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sub-label"
}, "Краткий заголовок/тема сотрудничества.", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Заголовок тех.задания", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sub-label"
}, "Краткий заголовок/тема технического задания.", -1));
const _hoisted_16 = {
  class: "flex-column-notcentered"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ваше предложение", -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sub-label"
}, "Введите Ваше предложение.", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ваша жалоба", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sub-label"
}, "Пожалуйста, разъясните ситуацию подробно.", -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ваше предложение", -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sub-label"
}, "Ваш текст сотрудничества.", -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ваше задание", -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sub-label"
}, "Введите состав технического задания. Обратите внимание, что в один тикет можно написать только одно задание. Для каждого задания создайте новый тикет.", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_radio_button = _resolveComponent("el-radio-button");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  const _directive_maska = _resolveDirective("maska");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_radio_group, {
    modelValue: $data.ui_ticket.type,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.ui_ticket.type = $event),
    size: $data.horListSize
  }, {
    default: _withCtx(() => [_createVNode(_component_el_radio_button, {
      label: "Предложение"
    }), _createVNode(_component_el_radio_button, {
      label: "Жалоба"
    }), _createVNode(_component_el_radio_button, {
      label: "Сотрудничество"
    }), $options.userData ? (_openBlock(), _createBlock(_component_el_radio_button, {
      key: 0,
      label: "Техническое задание"
    })) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["modelValue", "size"]), _createVNode(_component_el_form, {
    model: $data.ui_ticket,
    "label-width": "250px",
    class: "sc-form",
    "label-position": $data.labelPosition,
    rules: $data.rules,
    ref: "senderform"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      prop: "customer"
    }, {
      label: _withCtx(() => [_hoisted_2]),
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.ui_ticket.customer.firstname,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.ui_ticket.customer.firstname = $event),
        placeholder: "Ваше имя",
        size: "large"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
        modelValue: $data.ui_ticket.customer.lastname,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.ui_ticket.customer.lastname = $event),
        placeholder: "Ваша фамилия",
        size: "large"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), $data.ui_ticket.type != 'Техническое задание' ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 0,
      prop: "phone"
    }, {
      label: _withCtx(() => [_hoisted_3]),
      default: _withCtx(() => [_withDirectives(_createVNode(_component_el_input, {
        placeholder: "+# (###) ### ##-##",
        modelValue: $data.ui_ticket.customer.phone,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.ui_ticket.customer.phone = $event),
        size: "large"
      }, null, 8, ["modelValue"]), [[_directive_maska, '+7 (###) ### ##-##']])]),
      _: 1
    })) : _createCommentVNode("", true), $data.ui_ticket.type == 'Предложение' || $data.ui_ticket.type == 'Жалоба' ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 1
    }, {
      label: _withCtx(() => [_hoisted_4]),
      default: _withCtx(() => [_createVNode(_component_el_switch, {
        modelValue: $data.ui_ticket.pharmacy.forPharmacy,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.ui_ticket.pharmacy.forPharmacy = $event),
        size: "large",
        "active-text": "Да",
        "inactive-text": "Нет"
      }, null, 8, ["modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), $data.ui_ticket.pharmacy.forPharmacy ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 2,
      prop: "pharmacy"
    }, {
      label: _withCtx(() => [_hoisted_5]),
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.ui_ticket.pharmacy.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.ui_ticket.pharmacy.value = $event),
        class: "m-2",
        placeholder: "Select",
        size: "large"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "Не выбрана аптека",
          value: null
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.pharmacies, (i, ind) => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: ind,
            label: i.address,
            value: i.address
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), $data.ui_ticket.type == 'Сотрудничество' ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 3
    }, {
      label: _withCtx(() => [_hoisted_6]),
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.ui_ticket.partnership.type,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.ui_ticket.partnership.type = $event),
        class: "m-2",
        placeholder: "Select",
        size: "large"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "Не выбрано",
          value: null
        }), _createVNode(_component_el_option, {
          label: "Аренда помещений",
          value: "Аренда помещений"
        }), _createVNode(_component_el_option, {
          label: "Товар",
          value: "Товар"
        }), _createVNode(_component_el_option, {
          label: "Другое",
          value: "Другое"
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_divider, {
      "content-position": "left"
    }, {
      default: _withCtx(() => [_createTextVNode("Состав тикета")]),
      _: 1
    }), true ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 4
    }, [_createVNode(_component_el_form_item, {
      prop: "title"
    }, {
      label: _withCtx(() => [_createElementVNode("div", _hoisted_7, [$data.ui_ticket.type == 'Предложение' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_hoisted_8, _hoisted_9], 64)) : $data.ui_ticket.type == 'Жалоба' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_hoisted_10, _hoisted_11], 64)) : $data.ui_ticket.type == 'Сотрудничество' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_hoisted_12, _hoisted_13], 64)) : $data.ui_ticket.type == 'Техническое задание' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 3
      }, [_hoisted_14, _hoisted_15], 64)) : _createCommentVNode("", true)])]),
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.ui_ticket.title,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.ui_ticket.title = $event),
        placeholder: "Заголовок",
        size: "large"
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      prop: "content"
    }, {
      label: _withCtx(() => [_createElementVNode("div", _hoisted_16, [$data.ui_ticket.type == 'Предложение' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_hoisted_17, _hoisted_18], 64)) : $data.ui_ticket.type == 'Жалоба' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_hoisted_19, _hoisted_20], 64)) : $data.ui_ticket.type == 'Сотрудничество' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_hoisted_21, _hoisted_22], 64)) : $data.ui_ticket.type == 'Техническое задание' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 3
      }, [_hoisted_23, _hoisted_24], 64)) : _createCommentVNode("", true)])]),
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.ui_ticket.content,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.ui_ticket.content = $event),
        rows: 5,
        type: "textarea",
        placeholder: "Начните писать...",
        size: "large"
      }, null, 8, ["modelValue"])]),
      _: 1
    })], 64)) : _createCommentVNode("", true), _createVNode(_component_el_button, {
      class: "sc-sender-confirm",
      size: "large",
      type: "success",
      onClick: $options.sc_ticket_send,
      loading: $data.ui_ticket_sending
    }, {
      default: _withCtx(() => [_createTextVNode("Отправить тикет")]),
      _: 1
    }, 8, ["onClick", "loading"])]),
    _: 1
  }, 8, ["model", "label-position", "rules"])]);
}